import { getSandboxDomain, getSandboxUrl, getUrlDomain, middlewareUiUrl } from "./sandboxDomains";

export const services = [
    {
        key: "token",
        name: "Generador de token de acceso",
        shortName: "Token de acceso",
        route: "/token",
        domain: "Auth",
        description: "Generacion del access_token usado como Authorization Bearer en los endpoints del sandbox.",
        method: "POST",
        endpoint: "InitiateAuth",
        version: "1.0.0",
        icon: "auth",
    },
    {
        key: "nom151",
        name: "NOM151 / Fintech Pagos Middleware",
        shortName: "NOM151",
        route: "/nom151",
        baseUrl: getSandboxUrl("nom151"),
        domain: getSandboxDomain("nom151"),
        description: "Generacion de constancias NOM151 para flujos fintech.",
        method: "POST",
        endpoint: "/api/nom151",
        version: "prod-0.0.6.1",
        icon: "doc",
    },
    {
        key: "renapo",
        name: "RENAPO",
        shortName: "RENAPO",
        route: "/renapo",
        baseUrl: getSandboxUrl("renapo"),
        domain: getSandboxDomain("renapo"),
        description: "Validacion de CURP contra RENAPO.",
        method: "POST",
        endpoint: "/api/renapo",
        version: "prod-1.4.10.1",
        icon: "user",
    },
    {
        key: "listaNominal",
        name: "Lista Nominal",
        shortName: "Lista Nominal",
        route: "/lista-nominal",
        baseUrl: getSandboxUrl("lista-nominal"),
        domain: getSandboxDomain("lista-nominal"),
        description: "Validacion de INE en lista nominal.",
        method: "POST",
        endpoint: "/checkID",
        version: "prod-1.0.11.1",
        icon: "list",
    },
    {
        key: "commonFaceModels",
        name: "Modelos de reconocimiento facial",
        shortName: "Modelos faciales",
        route: "/common-face-models-api",
        baseUrl: getSandboxUrl("common-face-models-api"),
        domain: getSandboxDomain("common-face-models-api"),
        description: "Modelos de reconocimiento facial para calidad de imagen, embeddings y comparacion.",
        method: "GET/POST",
        endpoint: "/v1/*",
        version: "1.0.0",
        icon: "face",
    },
    {
        key: "kycSdkStorage",
        name: "KYC SDK Storage",
        shortName: "KYC SDK Storage",
        route: "/kyc-sdk-storage",
        baseUrl: getSandboxUrl("kyc-sdk-storage"),
        domain: getSandboxDomain("kyc-sdk-storage"),
        description: "Almacenamiento y consulta de resultados generados por el SDK KYC.",
        method: "GET/POST/PUT",
        endpoint: "/api/v1/sdk/*",
        version: "0.0.1",
        icon: "doc",
        hideFromDashboard: true,
    },
    {
        key: "middlewareUi",
        name: "Middleware UI",
        shortName: "Middleware UI",
        externalUrl: middlewareUiUrl,
        domain: getUrlDomain(middlewareUiUrl),
        description: "Demo web para consumir el flujo de onboarding y biometria.",
        method: "UI",
        endpoint: "Aplicacion web",
        version: "Demo",
        actionLabel: "Abrir servicio",
        icon: "screen",
    },
];
